<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <span class="tit">그룹{{groupNumber}} 저장소</span>
        <el-select v-model="dataindex" @change="changeDataindex">
          <el-option label="모든 저장소" value="log-*" />
          <el-option v-for="index in dataindexes" :key="index.dataindexId" :label="index.dataindexName" :value="index.dataindexId" />
        </el-select>
      </div>
      <div class="vertical-center-box" align="right">
        <el-button class="mr-r4" size="mini" @click="addFilterRow">필드추가</el-button>
        <el-button size="mini" type="primary" v-if="groupNumber === 1" @click="addGroup">그룹추가</el-button>
        <el-button size="mini" v-else @click="deleteGroup">그룹삭제</el-button>
      </div>
    </el-row>
    <el-row class="mr-b20">
      <el-table-wrapper ref="condTable" :columns="columns" :data="filterConditions" :show-search-tool="false" :show-custom-header="true" :pagination="false">
        <template slot-scope="scope" slot="filter-field-slot">
          <el-select v-model="scope.row.fieldId" @change="changeCondition(scope)" filterable>
            <el-option v-for="option in fieldOptions" :key="option.fieldId" :label="option.fieldName" :value="option.fieldId"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="filter-value-slot">
          <el-input v-if="scope.row.fieldId !== 'isChecked'" v-model="scope.row.fieldValue" @blur="changeCondition(scope)"></el-input>
          <el-select v-else v-model="scope.row.fieldValue" @change="changeCondition(scope)">
            <el-option label="확인" value="1" />
            <el-option label="미확인" value="0" />
          </el-select>
        </template>
        <!-- TODO negation flag = Y일 때 필터링되지 않는 문제 해결 후 주석 풀기 -->
        <!-- <template slot-scope="scope" slot="filter-negation-slot">
          <el-checkbox v-model="scope.row.negationOperatorFlag" true-label="N" false-label="Y"
          @change="changeCondition(scope.row.negationOperatorFlag, scope)"></el-checkbox>
        </template> -->
        <template slot-scope="scope" slot="filter-regex-slot">
          <el-checkbox v-model="scope.row.regexFlag" true-label="Y" false-label="N"
          @change="changeCondition(scope)"></el-checkbox>
        </template>
        <template slot-scope="scope" slot="delete-row-slot">
          <span class="c-pointer" v-if="scope.$index !== 0" @click="deleteFilterRow(scope)"><i class="fal fa-times"></i></span>
        </template>
      </el-table-wrapper>
    </el-row>
  </div>
</template>

<script>
import { cloneDeep, forEach, isEmpty, isNil, findIndex } from 'lodash';

import msgUtil from '@/utils/message';
import LogAPI from '@/api/log/integrated-log';

export default {
  name: 'WFilterConditionGroupTable',
  props: {
    groupId: Number,
    groupNumber: Number,
    dataindexId: String,
    conditions: Array,
    searchTags: Array,
    popupType: String,
  },
  data() {
    const columns = [
      {
        prop: 'fieldId',
        label: '필드',
        width: '120px',
        headerAlign: 'center',
        scopedSlot: 'filter-field-slot',
      },
      {
        prop: 'fieldValue',
        label: '값',
        headerAlign: 'center',
        scopedSlot: 'filter-value-slot',
      },
      // {
      //   label: '포함여부',
      //   width: '70px',
      //   headerAlign: 'center',
      //   scopedSlot: 'filter-negation-slot',
      // },
      {
        label: '정규표현식',
        width: '70px',
        headerAlign: 'center',
        scopedSlot: 'filter-regex-slot',
      },
      {
        width: '40px',
        scopedSlot: 'delete-row-slot',
      },
    ];
    return {
      columns,
      fieldOptions: [],
      dataindexes: [],
      dataindex: null,
      filterConditions: [],
      addCondition: [],
      deleteCondition: [],
      updateCondition: [],
      orderbyIndex: 1,
    };
  },
  watch: {
    conditions: {
      immediate: true,
      handler() {
        if (isEmpty(this.searchTags) || this.popupType !== 'ADD') {
          this.filterConditions = cloneDeep(this.conditions);
        }
        this.orderbyIndex = cloneDeep(this.conditions[this.conditions.length - 1].orderbyIndex);
      },
    },
    searchTags: {
      immediate: true,
      handler() {
        if (this.popupType === 'ADD') {
          // TODO 검색 태그를 추가 및 수정 팝업에 반영하는 여부를 결정한 뒤 수정 필요 (searchTags의 유무에 따라 분기 처리가 필요하지 않음)
          if (!isEmpty(this.searchTags) && (this.groupNumber === 1)) {
            this.filterConditions = [];
            this.searchTags.forEach((tag, index) => {
              if (index === 0) {
                this.filterConditions[0] = { fieldId: tag.field, fieldValue: tag.value, negationOperatorFlag: 'N', orderbyIndex: this.orderbyIndex, regexFlag: this.regex };
              } else {
                this.orderbyIndex += 1;
                const cond = { fieldId: tag.field, fieldValue: tag.value, negationOperatorFlag: 'N', orderbyIndex: this.orderbyIndex, regexFlag: this.regex };
                this.filterConditions.push(cond);
                this.addCondition.push(cond);
              }
            });
          } else {
            this.filterConditions = cloneDeep(this.conditions);
          }
        } else if (!isEmpty(this.searchTags) && (this.conditions.length !== 1 || !isEmpty(this.conditions[0].fieldValue))) {
          this.searchTags.forEach((tag) => {
            this.orderbyIndex += 1;
            const cond = { fieldId: tag.field, fieldValue: tag.value, negationOperatorFlag: 'N', orderbyIndex: this.orderbyIndex, regexFlag: this.regex };
            this.filterConditions.push(cond);
            this.addCondition.push(cond);
          });
        }
      },
    },
    dataindexId: {
      immediate: true,
      handler(value) {
        if (!isEmpty(value)) {
          this.dataindex = cloneDeep(value);
        }
      },
    },
    dataindex: {
      immediate: true,
      handler(value) {
        if (value === 'log-*') {
          this.loadDefaultField();
        } else if (!isEmpty(value)) {
          this.loadFieldData(value);
        }
      },
    },
  },
  created() {
    LogAPI.getUsingIndexList().then((response) => {
      if (response.data.success) {
        this.dataindexes = response.data.data;
      }
    }).catch((e) => {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '저장소 목록', false));
      throw new Error(e);
    });
  },
  methods: {
    /**
     * 선택한 저장소(인덱스)의 필드 정보를 조회해온다.
     * @author Minyeong
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    loadFieldData(value) {
      const params = {
        params: {
          dataindexId: value,
        },
      };
      LogAPI.getLogFieldsByIndex(params).then((response) => {
        if (response.data.success) {
          const fieldOptions = response.data.data;
          const timestampIdx = findIndex(fieldOptions, (item) => item.fieldId === 'timestamp');
          fieldOptions.splice(timestampIdx, 1);
          this.fieldOptions = fieldOptions;
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '필드 정보', false));
        throw new Error(e);
      });
    },
    /**
     * 기본 필드 정보만 조회해온다. ('모든 저장소' 선택 시)
     * @author Minyeong
     * @return {[type]} [description]
     */
    loadDefaultField() {
      LogAPI.getLogAllFields().then((response) => {
        if (response.data.success) {
          const fieldOptions = response.data.data;
          const timestampIdx = findIndex(fieldOptions, (item) => item.fieldId === 'timestamp');
          fieldOptions.splice(timestampIdx, 1);
          this.fieldOptions = fieldOptions;
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '기본 필드 정보', false));
        throw new Error(e);
      });
    },
    addFilterRow() {
      this.orderbyIndex += 1;
      this.filterConditions.push(
        { fieldId: this.fieldOptions[0].fieldId, fieldValue: '', negationOperatorFlag: 'N', orderbyIndex: this.orderbyIndex, regexFlag: 'N', dataindexId: this.dataindex },
      );
    },
    /**
     * 그룹 내 검색조건을 삭제한다.
     * @author Minyeong
     * @param  {[type]} scope [description]
     * @return {[type]}       [description]
     */
    deleteFilterRow(scope) {
      const addIndex = findIndex(this.addCondition, {
        fieldId: scope.row.fieldId,
        fieldValue: scope.row.fieldValue,
        negationOperatorFlag: scope.row.negationOperatorFlag,
        regexFlag: scope.row.regexFlag,
      });
      const updateIndex = findIndex(this.updateCondition, { conditionId: scope.row.conditionId });
      if (addIndex !== -1) {
        this.addCondition.splice(addIndex, 1);
      } else if (updateIndex !== -1) {
        this.updateCondition.splice(updateIndex, 1);
        this.deleteCondition.push(scope.row);
      } else {
        this.deleteCondition.push(scope.row);
      }
      this.filterConditions.splice(scope.$index, 1);
    },
    /**
     * [사용자 정의 필터 수정] 검색 조건이 변경될 경우 기존 데이터와 비교해 추가된 것은 addCondition에, 수정된 것은 updateCondition에 넣어줌
     * @author Minyeong
     * @param  {[type]} value [description]
     * @param  {[type]} scope [description]
     * @return {[type]}       [description]
     */
    changeCondition(scope) {
      // conditionId의 존재 유무로 add/update 분류
      if (isNil(scope.row.conditionId)) {
        // addCondition
        const index = findIndex(this.addCondition, {
          orderbyIndex: this.orderbyIndex,
        });
        if (index === -1) {
          this.addCondition.push(scope.row);
        }
      } else {
        // updateCondition
        const index = findIndex(this.updateCondition, { conditionId: scope.row.conditionId });
        if (index === -1) {
          this.updateCondition.push(scope.row);
        } else {
          this.updateCondition[index] = scope.row;
        }
      }
    },
    /**
     * dataindex가 변경되었을 때 변경된 dataindex를 conditions의 모든 항목에 반영시켜준다.
     * @author Minyeong
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    changeDataindex(value) {
      // 기존의 dataindexId와 동일하지 않을 때에만 설정해줌
      if (this.dataindexId !== value) {
        forEach(this.filterConditions, (item) => {
          item.dataindexId = value;
          item.fieldId = null;

          if (isNil(item.conditionId)) {
            const index = findIndex(this.addCondition, { orderbyIndex: this.orderbyIndex });
            if (index === -1) {
              this.addCondition.push(item);
            } else {
              this.addCondition[index].dataindexId = value;
              this.addCondition[index].fieldId = null;
            }
          } else {
            const index = findIndex(this.updateCondition, { conditionId: item.conditionId });
            if (index === -1) {
              this.updateCondition.push(item);
            } else {
              this.updateCondition[index].dataindexId = value;
            }
          }
        });

        if (!isEmpty(this.deleteCondition)) {
          forEach(this.deleteCondition, (item) => {
            item.dataindexId = value;
            item.fieldId = null;
          });
        }
      }
    },
    /**
     * 사용자 정의 필터 추가시 필요한 Parameter를 리턴한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    getGroupConditionParams() {
      return { groupId: this.groupId, condition: this.filterConditions, dataindexId: this.dataindex };
    },
    /**
     * 사용자 정의 필터 수정시 필요한 Parameter를 리턴한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    getUpdateConditionParams() {
      const params = {
        groupId: this.groupId,
        dataindexId: this.dataindex,
      };
      if (!isEmpty(this.addCondition)) {
        params.addCondition = this.addCondition;
      }
      if (!isEmpty(this.updateCondition)) {
        params.updateCondition = this.updateCondition;
      }
      if (!isEmpty(this.deleteCondition)) {
        params.deleteCondition = this.deleteCondition;
      }
      return params;
    },
    addGroup() {
      this.$emit('add-group', this.fieldOptions);
    },
    deleteGroup() {
      this.$emit('delete-group', this.groupId);
    },
    initUpdateCondition() {
      this.addCondition = [];
      this.updateCondition = [];
      this.deleteCondition = [];
      this.dataindex = 'log-*';
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/log-analysis/components/FilterConditionGroupTable.vue